'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global document */


var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'generic-tabs__tabs';

/* TODO *****
  Can we add a TODO into the component that we might need to add preloading capabilities
  for the images because when you switch tabs sometimes it jumps because of the images loading
  http://stackoverflow.com/questions/476679/preloading-images-with-jquery#answer-11274150
*/

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.handleListChange = _this.handleListChange.bind(_this);
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.state = {
      isMobile: false
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'handleListChange',
    value: function handleListChange(e) {
      e.preventDefault();
      if (this.props.handleChange) {
        this.props.handleChange(Number(e.target.getAttribute('data-index')));
        this.props.fireTracking('Tabs-' + e.target.text);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(e) {
      e.preventDefault();
      if (this.props.handleChange) {
        this.props.handleChange(e.target.selectedIndex);
        this.props.fireTracking('DropDown-' + e.target.value);
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs(items) {
      var _this2 = this;

      if (items) {
        var options = items.map(function (item, idx) {
          var selectedClass = _this2.props.value === idx ? 'selected' : '';
          var key = 'option-item' + idx;
          return _react2.default.createElement(
            'li',
            { key: key },
            _react2.default.createElement(
              'button',
              {
                className: ORGANISM_NAME + '__links ' + selectedClass,
                onClick: _this2.handleListChange,
                'data-index': idx
              },
              item.text
            )
          );
        });

        return _react2.default.createElement(
          'ul',
          { className: ORGANISM_NAME + '__list' },
          options
        );
      }
      return null;
    }
  }, {
    key: 'renderSelect',
    value: function renderSelect(items) {
      if (items) {
        var options = items.map(function (item, idx) {
          return _react2.default.createElement(
            'option',
            { value: idx, key: item.text },
            htmlToReactParser.parse(item.text)
          );
        });
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__select-wrapper' },
          _react2.default.createElement(
            'select',
            {
              className: ORGANISM_NAME + '__select',
              onChange: this.handleSelectChange,
              value: this.props.value
            },
            options
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.props.content.items;

      // Mobile render

      if (this.state.isMobile) {
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + ' col-xs-12' },
          this.renderSelect(items)
        );
      }
      // Desktop/Tablet/Default
      return _react2.default.createElement(
        'div',
        { className: ORGANISM_NAME + ' center-block text-xs-center col-md-12' },
        this.renderTabs(items)
      );
    }
  }]);

  return Tabs;
}(_react2.default.Component);

exports.default = Tabs;


Tabs.propTypes = {
  content: _propTypes2.default.shape({
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired).isRequired
  }),
  handleChange: _propTypes2.default.func,
  value: _propTypes2.default.number,
  fireTracking: _propTypes2.default.func
};

Tabs.defaultProps = {
  content: {
    items: [{
      text: '17 characters maximum'
    }, {
      text: '17 characters maximum'
    }]
  },
  fireTracking: function fireTracking() {},
  handleChange: function handleChange() {},
  value: 0
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-tabs/jsx/Tabs.js
// module id = 682
// module chunks = 4